import { DROP_ADMIN_LIST_SEARCH_FORM } from 'root/src/shared/descriptions/modules/moduleIds'

import changePassword from 'root/src/client/logic/dropEvent/thunks/dropAdminListSearch'

export default {
	[DROP_ADMIN_LIST_SEARCH_FORM]: [
		{
			action: changePassword,
		},
	],
}
